"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePricingDefaults = void 0;
const validatePricingDefaults = (defaults) => {
    return {
        min_price: defaults.min_price > 0,
        checkin_days: defaults.checkin_days.length > 0
    };
};
exports.validatePricingDefaults = validatePricingDefaults;
//# sourceMappingURL=validation.js.map